import _styled, { default as _styled2 } from "styled-components";
import React from "react";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { useNavLayout } from "~/features/app/app-header-v2/context";
type Props = {
  children: React.ReactNode;
};
export function BlogHero(props: Props) {
  const {
    children
  } = props;
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  const {
    isAnnouncementBarVisible
  } = useNavLayout();
  const topSpacing = isAnnouncementBarVisible ? {
    "marginTop": "calc(var(--announcement-bar-height) + var(--header-height))"
  } : {
    "marginTop": "var(--header-height)"
  };
  return <_StyledDiv $_css={[{
    "position": "relative",
    "zIndex": "10"
  }, topSpacing, {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }, themeStyle.border]}>
      <Wrap mode="light">
        <_StyledDiv2>{children}</_StyledDiv2>
      </Wrap>
    </_StyledDiv>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-xe5c2d-0"
})`${p => p.$_css}`;
var _StyledDiv2 = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "blog-hero___StyledDiv2",
  componentId: "sc-pupkjn-0"
})({
  "padding": "1.6rem",
  "@media (min-width: 1024px)": {
    "padding": "4rem"
  }
});